import WhyPrepareImage from '@/assets/Onboarding/WhyPrepareImage.png';
import Step1Icon from '@/assets/Onboarding/Step1Icon.png';
import Step2Icon from '@/assets/Onboarding/Step2Icon.png';
import Step3Icon from '@/assets/Onboarding/Step3Icon.png';
import { Button } from '@/components/ui/button';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const MBPIntro2Page = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <div className="flex flex-col items-center gap-5 mt-10">
          <img
            src={WhyPrepareImage}
            alt="Steps"
            className="size-40"
            width="160"
            height="160"
          />
          <p className="text-1.5xl nxs:text-center font-medium">
            Comment ça marche ?
          </p>
        </div>
      }
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Allons-y !
          </Button>
        </div>
      }
    >
      <div className="flex w-full flex-col gap-6">
        <div className="flex items-start gap-4">
          <img
            src={Step1Icon}
            alt="Step1Icon"
            className="size-9 mt-1"
            width="36"
            height="36"
          />
          <div className="flex flex-col flex-1 leading-5">
            <p className="font-light">
              Pour aider votre médecin à cibler vos priorités,
              <span className="font-medium">
                {' '}
                répondez à ce court auto-questionnaire
              </span>
            </p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <img
            src={Step2Icon}
            alt="Step2Icon"
            className="size-9 mt-1"
            width="36"
            height="36"
          />
          <div className="flex flex-col flex-1 leading-5">
            <p className="font-light">
              Votre médecin &apos;utilisera pour orienter la discussion et vous
              donner des
              <span className="font-medium"> conseils adaptés</span>
            </p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <img
            src={Step3Icon}
            alt="Step3Icon"
            className="size-9 mt-1"
            width="36"
            height="36"
          />
          <div className="flex flex-col flex-1 leading-5">
            <p className="font-light">
              Vous rédigerez ensemble un{' '}
              <span className="font-medium">
                Plan Personnalisé de Prévention{' '}
              </span>
              lors de votre consultation
            </p>
          </div>
        </div>
      </div>
    </PatientPageLayout>
  );
};
